/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import {
  ApiResponse,
  DocumentUrlData,
  ImageUrlData,
  RemovePayload,
} from "models";
import brandApi from "api/brand";
import { BrandPayload, BrandSubmitForm, UpdateBrandStatus } from "models/brand";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import brandLocationApi from "api/brandLocationApi";
// import { brandLocationActions } from "./brandLocationSlice";
import { BrandList, BrandLocations } from "models/brandLocation";
import documentApi from "api/document";
import { DocumentForm, StoreList } from "models/document";
import adminUserMgmtAdminApi from "api/adminUserMgmtAdminApi";
import { adminUserMgmtAdminUsersActions } from "./adminUsersSlice";
import {
  AdminUsersPayload,
  adminUserForm,
  updateAdminUserForm,
} from "models/adminManage";
// import BrandLocationAction from "../components/action";

function* getAdminUsers(action: PayloadAction<AdminUsersPayload>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAdminApi.getAdminUsersList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtAdminUsersActions.getAdminUsersSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || { message: "Network Error or CORS issue" };
    yield put(adminUserMgmtAdminUsersActions.getAdminUsersFailed(errorData));
  }
}

function* getAdminUserById(action: PayloadAction<AdminUsersPayload>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAdminApi.getAdminUsersById,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtAdminUsersActions.getAdminUserByIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || { message: "Network Error or CORS issue" };
    yield put(adminUserMgmtAdminUsersActions.getAdminUserByIdFailed(errorData));
  }
}

function* addAdminUser(action: PayloadAction<adminUserForm>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAdminApi.addAdminUser,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminUserMgmtAdminUsersActions.addAdminUserSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || { message: "Network Error or CORS issue" };
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminUserMgmtAdminUsersActions.addAdminUserFailed(errorData));
  }
}

function* updateAdminUser(action: PayloadAction<updateAdminUserForm>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAdminApi.updateAdminUser,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminUserMgmtAdminUsersActions.updateAdminUserSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || { message: "Network Error or CORS issue" };
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminUserMgmtAdminUsersActions.updateAdminUserFailed(errorData));
  }
}

function* deleteAdminUser(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAdminApi.deleteAdminUser,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminUserMgmtAdminUsersActions.deleteAdminUserSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || { message: "Network Error or CORS issue" };
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminUserMgmtAdminUsersActions.deleteAdminUserFailed(errorData));
  }
}

function* getStoreListData(action: PayloadAction<StoreList>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAdminApi.storeListApi,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtAdminUsersActions.getStoreListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || { message: "Network Error or CORS issue" };
    yield put(adminUserMgmtAdminUsersActions.getStoreListFailed(errorData));
  }
}

function* getProfileUrl(action: PayloadAction<ImageUrlData>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtAdminApi.getImageUrl,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminUserMgmtAdminUsersActions.getImageUrlSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || { message: "Network Error or CORS issue" };
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminUserMgmtAdminUsersActions.getImageUrlFailed(errorData));
  }
}

function* getRoleListData(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(adminUserMgmtAdminApi.getRoleList);
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtAdminUsersActions.getRoleListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || { message: "Network Error or CORS issue" };
    yield put(adminUserMgmtAdminUsersActions.getRoleListFailed(errorData));
  }
}

export default function* adminUserMgmtAdminUsersSaga() {
  yield takeLatest(adminUserMgmtAdminUsersActions.getAdminUsers.type, getAdminUsers);
  yield takeLatest(adminUserMgmtAdminUsersActions.getAdminUserById.type, getAdminUserById);
  yield takeLatest(adminUserMgmtAdminUsersActions.addAdminUser.type, addAdminUser);
  yield takeLatest(adminUserMgmtAdminUsersActions.updateAdminUser.type, updateAdminUser);
  yield takeLatest(adminUserMgmtAdminUsersActions.deleteAdminUser.type, deleteAdminUser);
  yield takeLatest(adminUserMgmtAdminUsersActions.getStoreList.type, getStoreListData);
  yield takeLatest(adminUserMgmtAdminUsersActions.getRoleList.type, getRoleListData);
  yield takeLatest(adminUserMgmtAdminUsersActions.getImageUrl.type, getProfileUrl);
  //   yield takeLatest(documentActions.getCustomerList.type, getCustomerListData);
}
